/**
 * @author gll
 * 模块说明：退货单
 */
import { Service } from '@/tools'

export class SupplierCommodityService<T extends TProcure.SupplierCommodity> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TProcure.SupplierCommodity}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 功能：分页查询新品列表
   * /api/procure/supplier/commodity/v1/page
   */
  page = <K extends T['ApiPage']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPage', data)

  /**
   * 新品修改
   * /api/procure/supplier/commodity/v1/updateCommodity
   */
  updateCommodity = <K extends T['ApiUpdateCommodity']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateCommodity', data)

  /**
   * 新品添加
   * /api/procure/supplier/commodity/v1/addCommodity
   */
  addCommodity = <K extends T['ApiAddCommodity']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAddCommodity', data)

  /**
   * 查询新品列表详情
   * /api/procure/supplier/commodity/v1/info
   */
  info = <K extends T['ApiInfo']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiInfo', data)

  /**
   * 新品导入
   * /api/procure/supplier/commodity/v1/importExcel
   */
  importExcel = <K extends T['ApiImportExcel']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiImportExcel', data, '操作成功')

  /**
   * 新品删除
   * /api/procure/supplier/commodity/v1/deleteCommodity
   */
  deleteCommodity = <K extends T['ApiDeleteCommodity']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDeleteCommodity', data, '操作成功')

  /**
   * 新品确认
   * /api/procure/supplier/commodity/v1/confirm
   */
  confirm = <K extends T['ApiConfirm']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiConfirm', data, '操作成功')

  /**
   * 新品批量提交
   * /api/procure/supplier/commodity/v1/batchSubmit
   */
  batchSubmit = <K extends T['ApiBatchSubmit']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiBatchSubmit', data, '操作成功')
}
